import { Component, HostBinding, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogButton, ConfirmationDialogData } from '@shared/models';

@Component({
	selector: 'app-confirmation-dialog',
	templateUrl: './confirmation-dialog.component.html',
	styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
	@HostBinding('class') hostClass = 'confirmation-dialog-host';
	defaultButtons: ConfirmationDialogButton[] = [
		{
			label: 'Cancel',
			color: '',
			class: 'btn-secondary',
			result: false
		},
		{
			label: 'Confirm',
			color: 'primary',
			class: 'btn-primary',
			result: true
		}
	];

	highlightCancel: boolean = false;

	isConfirmDisabled = true;

	reasonTypeList?: any;
	selectReasonType?: any;
	reasonText?: string;

	constructor(
		public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
	) {
		this.reasonTypeList = this.data.reasonTypeList;

		// Use provided buttons or fall back to defaults
		if (!this.data.buttons || this.data.buttons.length === 0) {
			this.data.buttons = this.defaultButtons;
		}

		this.isConfirmDisabled = !!this.reasonTypeList;

		// Handle backdrop clicks to trigger animation
		this.dialogRef.backdropClick().subscribe(() => {
			this.triggerCancelHighlight();
		});
	}

	onButtonClick(result: any): void {
		if (this.reasonTypeList) {
			const reasonText = this.selectReasonType?.name === 'Other'
				? this.reasonText
				: this.selectReasonType?.name;
			const response = {
				success: result,
				reasonType: this.selectReasonType?.value,
				reasonText
			};
			this.dialogRef.close(response);
		} else {
			this.dialogRef.close(result);
		}
	}

	triggerCancelHighlight(): void {
		this.highlightCancel = true;
		setTimeout(() => {
			this.highlightCancel = false;
		}, 200);
	}

	updateConfirmDisabled(): void {
		if (!this.reasonTypeList) {
			this.isConfirmDisabled = false;
			return;
		}

		this.isConfirmDisabled =
			!this.selectReasonType ||
			(
				this.selectReasonType?.name === 'Other' &&
				!this.reasonText?.trim()
			);
	}

	onReasonChange(reasonType: any): void {
		this.selectReasonType = reasonType;
		this.reasonText = undefined;
		this.updateConfirmDisabled();
	}

	onReasonTextChange(text: any): void {
		this.reasonText = text;
		this.updateConfirmDisabled();
	}
}

